export const getCategory = (res, t) => {
  return t('categories.' + res?.toLowerCase());
};
